<app-complex-modal-template
    class="overflow-visible"
    [canConfirm]="createCassetteForm.valid"
    [title]="'synoptic.addCassette' | transloco"
    (onClickEvent)="onClickEvent($event)">
    <form [formGroup]="createCassetteForm">
        <div class="flex flex-row item-start w-full mt-6 mb-6">
            <div class="flex flex-col w-80">
                <app-select
                    [isMultiSelect]="false"
                    [label]="'synoptic.cassette' | transloco: { COUNT: cassetteOptions().length }"
                    [placeholder]="'synoptic.enterCassetteName'"
                    [(options)]="cassetteOptions"
                    (optionSelected)="onSelectedCassetteChange($event)" />
            </div>
        </div>
    </form>
</app-complex-modal-template>
